import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ApiUrlService {
    private apiURL = environment.apiUrlBase + environment.apiVersion;

    constructor() { }

    //Assigned
    apiAssignmentsData() {
        const SLUG = 'assignment';
        return this.apiURL + SLUG;
    }

    apiGetEmployee() {
        const SLUG = 'assignment/external';
        return this.apiURL + SLUG;
    }
    //Assignments loan
    apiAssignmentsLoanData() {
        const SLUG = this.apiAssignmentsData() + '/assignment-loan';
        return SLUG;
    }

    // User
    apiUserParameterData() {
        const SLUG = 'parameter/users';
        return this.apiURL + SLUG;
    }

    // Roles
    apiRolesParameterData() {
        const SLUG = 'parameter/roles';
        return this.apiURL + SLUG;
    }
    apiRoleResourceData() {
        const SLUG = this.apiRolesParameterData() + '/resources';
        return SLUG;
    }

    //login
    apiAuthLogin(){
        const SLUG = 'auth/login';
        return this.apiURL + SLUG;
    }
    //logout
    apiAuthlogout(){
        const SLUG = 'auth/logout';
        return this.apiURL + SLUG;
    }

     //Setting
     apiSettingParameterData() {
        const SLUG = 'parameter/settings';
        return this.apiURL + SLUG;
    }

    apiAssignmentsEmployeeData() {
        const SLUG = this.apiAssignmentsData() + '/employee/';
        return SLUG;
    }


    apiTagParameterData() {
        const SLUG = 'parameter/tag';
        return this.apiURL + SLUG;
    }

    apiParkingLocationData() {
        const SLUG = 'parking/location';
        return this.apiURL + SLUG;
    }

    apiVehicleTypeData() {
        const SLUG =  'parameters/catalogs/vehicle-types';
        return this.apiURL+ SLUG;
    }


}
